import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppApiService } from 'src/app/app-api.service';
import { AppNotificationService } from 'src/app/app-notification.service';

@Injectable({
  providedIn: 'root'
})
export class AppointmentStatusesService extends AppApiService {
  public url: string | null = 'cesew/appointmentStatuses';

  constructor(
    protected http: HttpClient,
    protected notificationService: AppNotificationService,
    private appApiService: AppApiService
  ) {
    super(http, notificationService);
  }
}